import { atom, useAtom } from 'jotai';
import tabConfig from '../../config/tabConfig';

const firstTab = tabConfig.tabs.find(tab => tab)?.intent || '';
export const selectedTabAtom = atom(firstTab);

export function useSelectedTabAtom() {
  return useAtom(selectedTabAtom);
}
